var React = require('react');

function IconLinkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.56024 2.63794C3.56001 3.10941 3.37249 3.56148 3.03894 3.89469C2.7054 4.2279 2.25314 4.41497 1.78167 4.41473C1.3102 4.4145 0.858137 4.22698 0.524925 3.89343C0.191712 3.55989 0.0046473 3.10764 0.00488304 2.63617C0.00511877 2.1647 0.192635 1.71263 0.526182 1.37942C0.859728 1.0462 1.31198 0.859139 1.78345 0.859375C2.25492 0.859611 2.70699 1.04713 3.0402 1.38067C3.37341 1.71422 3.56048 2.16647 3.56024 2.63794ZM3.61357 5.7311H0.0582134V16.8594H3.61357V5.7311ZM9.23104 5.7311H5.69346V16.8594H9.19548V11.0197C9.19548 7.76655 13.4352 7.46434 13.4352 11.0197V16.8594H16.9462V9.81088C16.9462 4.32674 10.671 4.53117 9.19548 7.22436L9.23104 5.7311Z","fill":"#B7BAC1"}));
}

IconLinkedin.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = IconLinkedin;

IconLinkedin.default = IconLinkedin;
